import React from "react";

import { useTranslation } from "react-i18next";

const SuccessView = () => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold mt-[92px] mb-[18px] uppercase text-center">
        {t("success.title")}
      </h1>

      <div
        className="flex justify-center text-blue"
        dangerouslySetInnerHTML={{ __html: t("success.message") }}
      />
    </div>
  );
};

export default SuccessView;
